// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d86d0ffb","213":"eab6a00c","269":"11e3bb61","289":"dca0e4f1","355":"4d3edb89","453":"d855a71b","472":"c0ef119a","570":"dcc8247e","681":"99d92d80","682":"a4497dad","718":"6e1997ba","732":"0eb8fd42","972":"e3fa50fe","977":"2caed02d"}[chunkId] + ".chunk.js";
};